export default __webpack_public_path__ + "static/consultQrCode-0a7c3c33d86cae34e012ce3b7b40b577.jpg";